var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CompanyObjectRefSelect',{attrs:{"options":_vm.companyMeasureOptions,"default-option":_vm.defaultOption,"mode":_vm.mode,"object-type":"company_measure","placeholder":"Measure","external-path":"/definitions","external-query":{
    tab: 'measures',
  }},model:{value:(_vm.vModel),callback:function ($$v) {_vm.vModel=$$v},expression:"vModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }